import React, { useState, useEffect } from 'react'
import { useDataProvider } from 'react-admin'
import QuestionnaireForm from './QuestionnaireForm'
import { QuestionnaireType } from './OrganisationRiskQuestionnaireDirectory'

interface OrganisationRiskQuestionnaireProps {
  questionnaireId?: number
  isModal?: boolean
  onClose?: (updatedQuestionnaire?: any) => void
  initialQuestionnaireType?: QuestionnaireType
}

const OrganisationRiskQuestionnaire = ({
  questionnaireId,
  isModal = false,
  onClose,
  initialQuestionnaireType,
}: OrganisationRiskQuestionnaireProps) => {
  const dataProvider = useDataProvider()
  const [questionnaireType, setQuestionnaireType] = useState<QuestionnaireType>(
    initialQuestionnaireType || QuestionnaireType.RISK
  )
  const [loading, setLoading] = useState<boolean>(
    !!questionnaireId && !initialQuestionnaireType
  )

  // Fetch the questionnaire type if questionnaireId is provided and initialQuestionnaireType is not
  useEffect(() => {
    const fetchQuestionnaireType = async () => {
      if (questionnaireId && !initialQuestionnaireType) {
        try {
          const endpoint = `questionnaires/${questionnaireId}/organisations/current`
          const response = await dataProvider.custom(endpoint, {
            method: 'GET',
          })

          if (response.data && response.data.type) {
            // Convert string type to enum value
            const typeValue =
              response.data.type === 'preliminary'
                ? QuestionnaireType.PRELIMINARY
                : QuestionnaireType.RISK
            setQuestionnaireType(typeValue)
          }
        } catch (error) {
          console.error('Error fetching questionnaire type:', error)
        } finally {
          setLoading(false)
        }
      } else {
        setLoading(false)
      }
    }

    fetchQuestionnaireType()
  }, [dataProvider, questionnaireId, initialQuestionnaireType])

  // Define the endpoints for the questionnaire
  const getEndpoint = (
    organisationId: number | undefined,
    qId: number | undefined
  ) => {
    if (qId) {
      return organisationId
        ? `questionnaires/${qId}/organisations/${organisationId}`
        : `questionnaires/${qId}/organisations/current`
    }
    return organisationId
      ? `questionnaires/organisations/${organisationId}`
      : 'questionnaires/organisations/current'
  }

  if (loading) {
    return <div>Loading...</div>
  }

  return (
    <QuestionnaireForm
      questionnaireId={questionnaireId}
      isModal={isModal}
      onClose={onClose}
      customEndpoint={getEndpoint}
      questionnaireTypeLabel={
        questionnaireType === QuestionnaireType.PRELIMINARY
          ? 'Prequalification Questionnaire'
          : 'Risk Assessment'
      }
      questionnaireType={questionnaireType}
    />
  )
}

export default OrganisationRiskQuestionnaire
